import React from 'react';
import { useAboutUs } from '../hooks/usePrivacyQueries';
import { PageHeader, ContentCard, SkeletonLoader } from './ui';

export const AboutUs: React.FC = () => {
  const { data: aboutUsData, isLoading } = useAboutUs();

  return (
    <div>
      <PageHeader title="About Us" />

      {isLoading ? (
        <SkeletonLoader variant="text" count={6} />
      ) : (
        <ContentCard html={aboutUsData?.htmlContent || ''} />
      )}
    </div>
  );
};
